import React from "react";
import SuperAdminLeavePolicies from "../superadmin/policies/LeavePoliciesPage";

const LeavePoliciesPage = () => {
    return <SuperAdminLeavePolicies />;
};

export default LeavePoliciesPage;
